import { BaseQuery } from './type'

export const PLUGIN_TYPE = 'plugin-search-geolocation-rtree'
export const PLUGIN_ALIAS = 'Search Geolocation'

export const ObjectInitializerCfg = {
    expression: '=> every year',
    span: 'from ts 0',    
    isRealtime: true,
    queryProvider:'pipes'
} as BaseQuery

export const ObjectInitializerMixin = {
    type: PLUGIN_TYPE,
    active: true,
    config: ObjectInitializerCfg,
    fullQualifier: null,
    qualifier: null,
    status: {}
}
